import React, { useEffect, useState } from 'react';
import './AllUsers.css'; // Make sure to create this CSS file for styling
import { postData } from '../../../services/apiServices';
import Navbar from '../Navbar/Navbar';
import Loader from '../../MyComponents/Loader/Loader';
import UserModal from '../../MyComponents/UserModal/UserModal';
import toastService from '../../../services/toastService';
import { useNavigate } from 'react-router-dom';

function AllUsers() {
    const [users, setUsers] = useState([]);
    const [isLoading, setLoading] = useState(false)
    const [showModal, setShowModal] = useState(false);
    const [currentUser, setCurrentUser] = useState(null);
    const [isEdit, setIsEdit] = useState(false);
const navigate = useNavigate()

    useEffect(() => {
        getAllUsers()
    }, [showModal , navigate]);

    const getAllUsers = async () => {
        setLoading(true)
        const data = {
            "verification_token": "123456",
        }
        try {
            const result = await postData('/viewlist', data)
            console.log(result, "all users list")
            setUsers(result?.users)
            setLoading(false)

        } catch (error) {
            console.log(error, "get user error")
            setLoading(false)
        }

    }

    const handleDelete = async (userId) => {
        const confirmed = window.confirm("Are you sure you want to delete this user?");
        if (confirmed) {
            deleteUser(userId)
        }
    };

    const deleteUser = async (userid) => {
        setLoading(true)
        const data = {
            verification_token: "123456",
            table: "Users",
            id: userid,
        };

        try {
            const result = await postData('/delete', data);
            toastService.showSuccess(`User deleted Successfully`);
            getAllUsers();
            setLoading(false)
        } catch (error) {
            console.log(error, "get user error");
            toastService.showError("Something went wrong");
            setLoading(false)
        } finally {
            setLoading(false)

        }
    };



    const handleDisable = async (user) => {
        disableUser(user)
    };


    const disableUser = async (useData) => {
        setLoading(true)
         const updatedStatus = useData?.status === "active" ? "inactive" : "active";

        const data = {
            verification_token: "123456",
            table: "Users",
            status: updatedStatus,
            id: useData?.id,
        };

        try {
            const result = await postData('/edit', data);
              toastService.showSuccess(`User ${useData?.status == "active" ? "Disable" : "Active"} Successfully`);
            getAllUsers();
            setLoading(false)
        } catch (error) {
            console.log(error, "get user error");
            toastService.showError("Something went wrong");
            setLoading(false)
        } finally {
            setLoading(false)
        }
    };


    const handleAddUser = () => {
        setIsEdit(false); // This is for adding a new user
        setCurrentUser(null);
        setShowModal(true);
    };

    const handleEditUser = (user) => {
        setIsEdit(true);
        console.log(user, "AS?FA?DFS?AD?FA?SD?A???A?A?d")
        setCurrentUser(user);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setCurrentUser(null);
    };

    const getUserTypeColor = (userType) => {
        switch (userType) {
            case 'supervisor':
                return '#3B5999';
            case 'user':
                return "#565656";
            case 'superadmin':
                return '#00C18B';
            default:
                return 'transparent';
        }
    };

    return (
        <>
            <Loader isLoading={isLoading} />
            <div className="all-users">
                <Navbar />

                <h2 className="header">
                    All Users
                    <button className="add-user-button" onClick={handleAddUser}>Add User</button>
                </h2>
                <div className="user-cards">
                    {users.map(user => (
                        <div key={user.id} className="user-card">
                            <div className="user-info">
                                <span className="user-name">{`${user.firstname} ${user.lastname}`}</span>
                                <span className="user-type" style={{ backgroundColor: getUserTypeColor(user.usertype) }}>
                                    {user.usertype}
                                </span>
                            </div>
                            <div className="user-email">{user.email}</div>
                            <div className="user-phone">Phone : {user.phone}</div>
                            <div className="user-status">Status : {user.status.charAt(0).toUpperCase() + user.status.slice(1)}</div>
                            <div className="user-buttons">
                                <button className="btn delete-btn" onClick={() => handleDelete(user.id)}>Delete</button>
                                <button className="btn edit-btn" onClick={() => handleEditUser(user)}>Edit</button>
                                <button className="btn disable-btn" onClick={() => handleDisable(user)}>{user?.status == "active" ? "Disable" : "Enable"}</button>
                            </div>
                            {showModal && (
                                <UserModal
                                    show={showModal}
                                    handleClose={handleCloseModal}
                                    isEdit={isEdit}
                                    userData={currentUser}
                                    refreshUsers={() =>{getAllUsers()}}
                                />
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}

export default AllUsers;